document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('drgPoliciesModal');
  if (!modal) return;

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const openButtons = document.querySelectorAll('[data-drg-policies-open]');
  const closeButtons = modal.querySelectorAll('[data-drg-policies-close]');
  const policiesTriggers = document.querySelectorAll('.drg-policies-trigger');

  const setTriggerOpenState = (isOpen) => {
    policiesTriggers.forEach((trigger) => {
      trigger.classList.toggle('is-open', isOpen);
    });
  };

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    setTriggerOpenState(true);
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    setTriggerOpenState(false);
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target.matches('.drg-policies-modal__overlay')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
});